  document.addEventListener('DOMContentLoaded', () => {
    // Select all buttons with the "open-modal" class
    const modalButtons = document.querySelectorAll('.open-modal');
    if(modalButtons) {
          // Loop through each button and add a click event listener
    modalButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            // Prevent the default link behavior
            event.preventDefault();

            // Display the modal (example logic, replace with your own modal handling)
            const modal = document.getElementById('my-modal');
            if (modal) {
                modal.style.display = 'block'; // Show the modal
            }
        });
    });
    }

});